/**
 * plural.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: "plural"})
export class PluralizationPipe implements PipeTransform {

  public transform (
    value : number,
    singular : string,
    plural : string = (singular + "s")
  ) : string
  {
    return value + " " + ((value === 1) ? singular : plural);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/plural.pipe.ts